import { Component, Vue, Emit } from "vue-property-decorator";
import store from "@/store";
import VueRouter from "vue-router";
// @ is an alias to /src
@Component
export default class FormLogin extends Vue {
  private name = "FormLogin";
  private username = null;
  private password = null;
  private error: number | null = null;
  get lang(): string {
    return store.getters["auth/lang"];
  }
  @Emit()
  private async onSubmit() {
    this.error === null;
    try {
      const params = {
        username: this.username,
        password: this.password,
      };
      await store
        .dispatch("auth/login", params)
        .then((response: any) => {
          this.password = null;
          if (response) {
            this.error = null;
            if (response.redirectUrl) {
              this.username = null;
              // location.href = response.redirectUrl;
            } else if (this.$route.query.redirect) {
              this.$router.push(String(this.$route.query.redirect));
            } else {
              let url = "/" + this.lang + "/";
              if (this.lang === "ja") {
                url = "/";
              }
              this.$router.push(url);
            }
          }
        })
      }catch(e){
        this.error = e.status;
      }
  }
  @Emit()
  private clickLineButton() {
    this.$router.push({
      path: "/line-auth",
      query: {
        from: this.$route.fullPath,
      },
    });
  }
}
